var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUnion(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 144,
    height: 118,
    viewBox: "0 0 144 118",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.6589 66.6349H0V0.872437H65.7625V77.6206C65.7625 99.3932 48.0495 117.106 26.2769 117.106H11.8035V89.0026H26.2769C32.553 89.0026 37.6589 83.8967 37.6589 77.6206V66.6349ZM78.1281 66.6349V0.872437H143.891V77.6206C143.891 99.3932 126.178 117.106 104.405 117.106H89.9316V89.0026H104.405C110.681 89.0026 115.787 83.8967 115.787 77.6206V66.6349H78.1281Z",
    fill: "#BFBFBF",
    fillOpacity: 0.08
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnion);
export default __webpack_public_path__ + "static/media/union.4097fd68067d1a23821d0c3875f620c9.svg";
export { ForwardRef as ReactComponent };